import { InjectionToken } from "@angular/core";
import { ExternalPaymentModel } from "../../models/payment-models";
export const GATEWAY_PAYMENT_STATUS = {
    SUCCESS: "success",
    CANCEL: "cancel",
    ERROR: "error",
    INPROCESS: "inProcess"
}
export const PAYMENT_TOKEN = new InjectionToken<ExternalPaymentModel>('PAYMENT_TOKEN');
export const GATEWAY_PAYMENT_CODE = {
    DATATRANS: "DATATRANS",
    PAYSAFE: "PAYSAFE",
    ECOMMPAY: "ECOMMPAY",
    GOCARDLESS: 'GOCARDLESS'
}